import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.592-12.54a.75.75 0 0 0-1.184-.92l-4.007 5.151a.25.25 0 0 1-.365.033l-2.534-2.281a.75.75 0 1 0-1.004 1.114l2.535 2.282a1.75 1.75 0 0 0 2.552-.227z"
      clipRule="evenodd"
    />
  </svg>
);
export const IconCheckCircleSolid = withDynamicStroke(Icon);
